import AutoLockMessage from './AutoLockMessage';
export default AutoLockMessage;
